module.exports = __webpack_public_path__ + "static/media/deskDraft2.e932dc65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/deskDraft2.jpg
// module id = 161
// module chunks = 0